import { Augmentation } from "./Augmentation";
import { IMap } from "../types";

export const StaticAugmentations: IMap<Augmentation> = {};
